export const TRANSLATION_KEYS = {
    ConfirmText: "common.webchat.confirmText",
    MeetingModalTooltip: "common.webchat.meetingModalTooltip",
    TeamsMeetingTooltip: "common.webchat.teamsMeetingTooltip",
    SolutionModalTooltip: "common.webchat.solutionModalTooltip",
    MessageLabel: "common.webchat.messageLabel",
    MessagePlaceholder: "common.webchat.messagePlaceholder",
    MessageErrorMessage: "common.webchat.messageErrorMessage"
};